import 'arrive';
import 'waypoints/lib/noframework.waypoints.min.js';
import { ScrollTrigger } from "../../lib/_scroll-trigger";
import {gsap} from "gsap";


const globalScrub = 1;

document.arrive('#time-1970 .block-2', {existing: true}, function() {
    const year = this.querySelector('.year');
    const imgScaleContainer = this.querySelector('.image');
    const img = this.querySelector('.img-scale-wrapper');
    const caption = this.querySelector('.caption');



    ScrollTrigger.matchMedia({
        // large
        "(min-width: 1200px)": function () {

        },
        "(max-width: 768px)": function () {
        },
    });
    const st = {
        trigger: this,
        start: "10% 70%",
        end: "bottom 10%",
        scrub: globalScrub
    };
    const yearBottomBreakpoint = Object.assign({}, st)
    yearBottomBreakpoint["end"] = "bottom 70%";

    gsap.to(year, {
        scrollTrigger: yearBottomBreakpoint,
        scale: 1.6,
        y: (imgScaleContainer.clientHeight / 2),
        color: '#fff',
        textShadow: "0 20px 75px rgba(0,0,0,0.7)"
    });


    ScrollTrigger.matchMedia({
        // large
        "(min-width: 1200px)": function () {


            gsap.fromTo(img, {
                scrollTrigger: st,
                scale: 1.6
            },{
                scrollTrigger: st,
                scale: 1
            })

            gsap.to(caption, {
                scrollTrigger: st,
                y: -(imgScaleContainer.clientHeight * 0.25)
            })

            gsap.to(imgScaleContainer, {
                scrollTrigger: st,
                scale: 0.7,
                y: '-20vh'
            })

        },
        "(max-width: 1199px) and (min-width: 768px)": function () {

            gsap.to(imgScaleContainer, {
                scrollTrigger: st,
                scale: 0.85,
                y: '-10vh'
            })

            gsap.to(caption, {
                scrollTrigger: st,
                y: -(imgScaleContainer.clientHeight * 0.15)
            })

            gsap.fromTo(img, {
                scrollTrigger: st,
                scale: 1.6
            },{
                scrollTrigger: st,
                scale: 1
            })
        },
        "(max-width: 767px)": function () {

            gsap.to(imgScaleContainer, {
                scrollTrigger: st,
                scale: 0.85,
                y: '-3vh'
            })

            gsap.to(caption, {
                scrollTrigger: st,
                y: -(imgScaleContainer.clientHeight * 0.15)
            })

            gsap.fromTo(img, {
                scrollTrigger: st,
                scale: 1.6
            },{
                scrollTrigger: st,
                scale: 1
            })
        },
    });
});

document.arrive('#time-1970 .block-3', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = this.querySelector('.image img');
    const caption = this.querySelector('.caption');

    const st = {
        trigger: this,
        start: "top 90%",
        end: "bottom 10%",
        scrub: globalScrub,
        markers: false
    };

    const containerFrom = {
        scrollTrigger: st,
        x: '-2.5vw',
        y: 0
    }

    const containerTo = {
        scrollTrigger: st,
        x: '5vw',
        y: '-15vh'
    }

    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {

            gsap.fromTo(
                caption,
                containerFrom,
                containerTo
            );

            gsap.to(img, {
                scrollTrigger: st,
                scale: 1.6
            });

            gsap.fromTo(
                imgContainer,
                containerFrom,
                containerTo
            );

        },
        "(max-width: 991px) and (min-width: 769px)": function () {

            gsap.fromTo(
                caption,
                {
                    scrollTrigger: st,
                    y: 0
                },
                {
                    scrollTrigger: st,
                    y: '-5vh'
                }
            );

            gsap.to(img, {
                scrollTrigger: st,
                scale: 1.6
            });

            gsap.fromTo(
                imgContainer,
                {
                    scrollTrigger: st,
                    y: 0
                },
                {
                    scrollTrigger: st,
                    y: '-5vh'
                }
            );

        },
        "(max-width: 768px)": function () {

            gsap.fromTo(
                caption,
                {
                    scrollTrigger: st,
                    y: 0
                },
                {
                    scrollTrigger: st,
                    y: '-5vh'
                }
            );

            gsap.to(img, {
                scrollTrigger: st,
                scale: 1.6
            });

            gsap.fromTo(
                imgContainer,
                {
                    scrollTrigger: st,
                    y: 0
                },
                {
                    scrollTrigger: st,
                    y: '-5vh'
                }
            );

        }
    });
});

document.arrive('#time-1970 .block-4', {existing: true}, function() {
    const time = this.querySelector('.time');
    const timeBackface = this.querySelector('.time-backface');
    const img = this.querySelector('.image img');
    const imgContainer = this.querySelector('.image');
    const caption = this.querySelector('.caption');
    const st = {
        trigger: this,
        start: "top 90%", // when the top of the trigger hits the top of the viewport
        end: "bottom 10%", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    const yearBottomBreakpoint = Object.assign({}, st)
    yearBottomBreakpoint["end"] = "bottom 70%";
    yearBottomBreakpoint["start"] = "top center";
    timeBackface.style.width = time.offsetWidth

    gsap.to(img, {
        scrollTrigger: st,
        scale: 2
    });

    gsap.fromTo(
        time,
        {
            scrollTrigger: yearBottomBreakpoint,
            y: -(imgContainer.clientHeight / 2),
        },
        {
            scrollTrigger: yearBottomBreakpoint,
            y: (caption.clientHeight) + 50,
        }
    );

    gsap.fromTo(
        timeBackface,
        {
            scrollTrigger: yearBottomBreakpoint,
            y: -(imgContainer.clientHeight / 2),
        },
        {
            scrollTrigger: yearBottomBreakpoint,
            y: (caption.clientHeight) + 50,
        }
    );
});